export const TIMER_ARRAY_UNITS = ['weeks', 'days', 'hours', 'minutes'];

export function calculateTimerOffset(timerArray): number {
  return (
    timerArray.getRawValue()[0] * 7 * 24 * 60 +
    timerArray.getRawValue()[1] * 24 * 60 +
    timerArray.getRawValue()[2] * 60 +
    timerArray.getRawValue()[3]
  );
}

export function setTimerValues(timerOffset, timerArray) {
  timerArray.controls[0].setValue(Math.floor(timerOffset / (7 * 24 * 60)));
  timerArray.controls[1].setValue(Math.floor((timerOffset % (7 * 24 * 60)) / (24 * 60)));
  timerArray.controls[2].setValue(Math.floor((timerOffset % (24 * 60)) / 60));
  timerArray.controls[3].setValue(Math.floor(timerOffset % 60));
}
